import { Badge } from '@/shared/ui/badge'

interface Props {
  code: string | null
  label: string | null
}

const ReviewTypeBadge = ({ code, label }: Props) => {
  if (!label) return null

  switch (code) {
    case 'CNM':
      return <Badge variant="warning">{label}</Badge>
    case 'ODE':
      return <Badge variant="destructive">{label}</Badge>
    case 'NPT':
      return <Badge variant="secondary">{label}</Badge>
    default:
      return <Badge variant="outline">{label}</Badge>
  }
}

export default ReviewTypeBadge
